module.exports = __webpack_public_path__ + "img/1.9d6d3c59.png";